import script from "./ButtonArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./ButtonArea.vue?vue&type=script&setup=true&lang=ts"

import "./ButtonArea.vue?vue&type=style&index=0&id=7e20f62f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e20f62f"]])

export default __exports__